import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-[#FDFBF7]';
  const variants = {
    primary: 'bg-[#4A2C40] text-[#FDFBF7] hover:bg-[#3a2232] focus-visible:ring-[#4A2C40]',
    secondary: 'bg-[#F3EFE7] text-[#4A2C40] hover:bg-[#e6dfd1] focus-visible:ring-[#4A2C40]',
    outline: 'border border-[#4A2C40] text-[#4A2C40] hover:bg-[#F3EFE7] focus-visible:ring-[#4A2C40]',
    ghost: 'text-[#4A2C40] hover:bg-[#F3EFE7] hover:text-[#3a2232] focus-visible:ring-[#4A2C40]'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-116">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-117" />}
      {children}
    </button>;
}